import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';

@Component({
  selector: 'app-direccion-particular',
  templateUrl: './direccion-particular.component.html',
  styleUrls: ['./direccion-particular.component.css']
})
export class DireccionParticularComponent implements OnInit, AfterViewInit {
  direccionForm: FormGroup | any;
  autocomplete: google.maps.places.Autocomplete | any;
  persona: any;
  formFirmado = false;
  @ViewChild('calleInput') calleInput: ElementRef | any;
  
  constructor(private fb: FormBuilder, private stepperService: StepperService, private dataService: DataService, private personaService: PersonaService,
    private commonService: CommonService, private zone: NgZone) {
    this.direccionForm = this.fb.group({
      guid: new FormControl(null),
      calle: new FormControl({value: "", disabled: true}, [Validators.required]),
      numero: new FormControl({value: "", disabled: true}, [Validators.required, Validators.pattern('^[0-9]*$')]),
      depto: new FormControl(''),
      comuna: new FormControl({value: "", disabled: true}, [Validators.required]),
      // ciudad: new FormControl('', [Validators.required]),
      region: new FormControl({value: "", disabled: true}, [Validators.required]),
      pais: new FormControl({value: "", disabled: true}, [Validators.required])
    });
  }

  public ngOnInit(): void {
    this.personaService.persona$.subscribe((nuevaPersona) => {
      if (nuevaPersona && this.persona !== nuevaPersona) {
        this.persona = nuevaPersona;
        this.commonService.setFormGroupValues(this.direccionForm, nuevaPersona.estadoSituacion.direccionParticular);
        
        if (nuevaPersona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
          this.formFirmado = true;
          this.direccionForm.disable();
        }
      }
    });
  }



  enviarFormulario(){
    if(this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado'){
      this.stepperService.nextStep();  
      return;
    }
      if(!this.direccionForm.invalid) {
        if(this.direccionForm.get('guid').value == null){
          this.direccionForm.removeControl('guid');
        }
        var url = `estado-situacion/${this.personaService.getPersonaGuid()}/direccion-persona`;
        this.dataService.postData(this.direccionForm.getRawValue(), url).subscribe({
          next: (v) => {
            this.direccionForm.get('numero').disable();
            this.stepperService.nextStep();   
          },
          error: (e) => console.log(e),
          complete: () => {
            this.personaService.setPersona();
          },
        });   
      }else{
        this.direccionForm.markAllAsTouched();
      }
  }

  volver(){
    this.stepperService.prevStep();
  }

  ngAfterViewInit() {
    this.initAutocomplete();
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(
      this.calleInput.nativeElement,
      {
        componentRestrictions: { country: 'CL' },
        types: ['route'],
          // 'establishment' / 'address' / 'geocode'
      }
    );

    // Agregar un listener para manejar el lugar seleccionado
    this.autocomplete.addListener('place_changed', () => {
      this.direccionForm.get('depto').setValue('');
      this.zone.run(() => {
        // Manejar el lugar seleccionado aquí, por ejemplo:
        const selectedPlace = this.autocomplete.getPlace();

        this.direccionForm.patchValue({
          numero: this.getLongNameByType(selectedPlace.address_components, 'street_number'),
          calle: this.getLongNameByType(selectedPlace.address_components, 'route'),
          comuna: this.getLongNameByType(selectedPlace.address_components, 'administrative_area_level_3'),
          // ciudad: this.getLongNameByType(selectedPlace.address_components, 'locality'),
          region: this.getLongNameByType(selectedPlace.address_components, 'administrative_area_level_1'),
          pais: this.getLongNameByType(selectedPlace.address_components, 'country')
        })
        if (this.getLongNameByType(selectedPlace.address_components, 'street_number') === null) {
          this.direccionForm.get('numero').enable();
          console.log('No se encontró número de calle');
        }else{
          this.direccionForm.get('numero').disable();
        }
      });
    });
  }

  getLongNameByType(results: any[], targetType: string): string | null {
    const result = results.find((item) => item.types.includes(targetType));
    return result ? result.long_name : null;
  }

}
